module.exports = "<!-- <div class=\"sidebar-footer\"></div> -->\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/app-sidebar-footer/app-sidebar-footer.component.html
// module id = ../../../../../src/app/components/app-sidebar-footer/app-sidebar-footer.component.html
// module chunks = main